<template>
  <div class="col-3">
    <slot />
  </div>
</template>
